import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { WarningDialogComponent } from 'src/app/components/warning-dialog/warning-dialog.component';
import { AccountManagementClientApiModel } from 'src/app/models/api/accountManagement.model';
import { AccountManagementHttpService } from 'src/app/services/httpServices/accountManagementHttpService/account-management-http-service.service';

@Component({
  selector: 'app-account-apis',
  templateUrl: './account-apis.component.html',
  styleUrls: ['./account-apis.component.scss'],
})
export class AccountApisComponent implements OnInit, OnDestroy {
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public clientDetails?: AccountManagementClientApiModel;
  public showNoData = false;

  private _accountApiDetailsSubscription$: Subscription;
  private readonly _accountApiKeyRotationSubscription$?: Subscription;

  constructor(
    private readonly _accountManagementHttpService: AccountManagementHttpService,
    private readonly _matDialog: MatDialog
  ) {
    this.handleSecretKeyRotationAction = this.handleSecretKeyRotationAction.bind(this);
  }

  ngOnInit(): void {
    this.isLoading$.next(true);

    this._accountApiDetailsSubscription$ = this._accountManagementHttpService.apiDetails().subscribe(
      (clientDetails) => {
        this.clientDetails = clientDetails;
        this.isLoading$.next(false);
      },
      (error) => {
        if (error.status == 404) {
          this.isLoading$.next(false);
          this.showNoData = true;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this._accountApiDetailsSubscription$.unsubscribe();
    this._accountApiKeyRotationSubscription$?.unsubscribe();
  }

  public handleSecretKeyRotationAction() {
    const observable: Observable<string> = this._accountManagementHttpService.rotateClientSecret();

    return observable;
  }

  public rotateSecretClicked(): void {
    const dialogRef = this._matDialog.open(WarningDialogComponent, {
      data: {
        elementsIds: [],
        elementsNames: [],
        title: 'userManagementPage.apisPage.areYouSureTitle',
        body: 'userManagementPage.apisPage.areYouSureBody',
        notificationMsgLabelPath: 'userManagementPage.apisPage.secretRotationSucceeded',
        actionCallback: this.handleSecretKeyRotationAction,
      },
      disableClose: false,
      panelClass: 'sized-popup-dialog-container',
    });
    dialogRef.afterClosed().subscribe((clientSecret) => {
      if (clientSecret && this.clientDetails) {
        this.clientDetails.clientSecret = clientSecret;
      }
    });
  }
}
